(function (Drupal, $) {
  Drupal.behaviors.viewsNav = {
    attach: function (context, settings) {
    'use strict';

      $(function() {
        $(".views-nav:not(.views-nav--sub)", context).tinyNav({
          active: 'is-active', // String: Set the "active" class
          link_selector: '.views-nav__link',
          opt_group: true,
          header: 'Galleries'
        });

        var views_nav_group = context.querySelectorAll('.views-nav .views-nav__link--nolink');

        for (var i = 0; i < views_nav_group.length; i++) {
          views_nav_group[i].addEventListener('click', function (e) {
            var className = 'is-open';
            $(this).next().toggle(className);
            e.preventDefault();
          });

          if($(views_nav_group[i]).parent().find('.is-active').length > 0) {
            $(views_nav_group[i]).next().addClass('is-open');
          }
        }
      });
    }
  }
})(Drupal, jQuery);
